<div class="input-group stc-input-group" *ngIf="control">
  <label *ngIf="inputName">
    {{ inputName | translate }}
    <span class="required-star" *ngIf="showRequiredStar || control.hasError('required')">*</span>
  </label>
  <ng-container [ngSwitch]="appearance">
    <ng-container *ngSwitchCase="'material'">
      <mat-form-field>
        <input
          type="text"
          [id]="inputId"
          [name]="inputName"
          matInput
          [placeholder]="inputPlaceholder ? inputPlaceholder : ''"
          autocomplete="off"
          [formControl]="control"
          [readonly]="disabled"
          (keydown)="onKeyDown($event)"
          (paste)="onPaste($event)"
          (input)="onInput($event)"
          [attr.inputmode]="allowDecimal ? 'decimal' : 'numeric'"
        />
      </mat-form-field>
      <div class="errors" *ngIf="control.invalid && control.touched">
        <span *ngIf="control.hasError('required')">
          {{ 'field_required' | translate }}
        </span>
        <span *ngIf="control.hasError('max')">
          {{ 'Please enter number less than or equal ' + control.getError('max').max | translate }}
        </span>
        <span *ngIf="control.hasError('min')">
          {{ 'Please enter number greater than or equal ' + control.getError('min').min | translate }}
        </span>
        <span *ngIf="control.hasError('pattern')">
          {{ 'Please enter a valid number' | translate }}
        </span>
        <span *ngIf="control.hasError('notZero')">
          {{ 'Please enter a non-zero number' | translate }}
        </span>
      </div>
    </ng-container>
    <div class="plain-input-wrapper" *ngSwitchCase="'plain'">
      <input
        type="text"
        [id]="inputId"
        [name]="inputName"
        [placeholder]="inputPlaceholder ? inputPlaceholder : ''"
        autocomplete="off"
        [formControl]="control"
        [readonly]="disabled"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        (input)="onInput($event)"
        [attr.inputmode]="allowDecimal ? 'decimal' : 'numeric'"
      />
      <div class="errors" *ngIf="control.invalid && control.touched">
        <span *ngIf="control.hasError('required')">
          {{ 'field_required' | translate }}
        </span>
        <span *ngIf="control.hasError('max')">
          {{ 'Please enter number less than or equal ' + control.getError('max').max | translate }}
        </span>
        <span *ngIf="control.hasError('min')">
          {{ 'Please enter number greater than or equal ' + control.getError('min').min | translate }}
        </span>
        <span *ngIf="control.hasError('pattern')">
          {{ 'Please enter a valid number' | translate }}
        </span>
        <span *ngIf="control.hasError('notZero')">
          {{ 'Please enter a non-zero number' | translate }}
        </span>
      </div>
    </div>
  </ng-container>
</div>
